import { render, staticRenderFns } from "./UsersPrivilegeTreasuriesTransaction.vue?vue&type=template&id=f1fe3344&scoped=true&"
import script from "./UsersPrivilegeTreasuriesTransaction.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeTreasuriesTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fe3344",
  null
  
)

export default component.exports